<template>
  <cst-page-template :hide-menu="true">
    <header-menu />
    <div class="bulk-future-prices-page">
      <div class="page-header">
        <h1>Toekomstige prijzen</h1>
      </div>

      <div class="content-section">
        <bulk-upload-future-prices @file-uploaded="handleFileUpload" />
        <div class="process-actions">
          <app-button
            v-if="processingComplete"
            data-qa="reset-bulk-future-prices"
            @click="resetPage"
          >
            {{ i18n.t('/change-order/bulk-price/reset') }}
          </app-button>
          <app-button
            :disabled="isProcessing || isFinishedProcessing"
            data-qa="start-processing-bulk-future-prices"
            @click="prepareForProcessing"
          >
            {{ i18n.t('/change-order/bulk-price/start') }}
          </app-button>
          <app-button
            v-if="processingComplete"
            data-qa="download-results-bulk-future-prices"
            @click="downloadResult"
          >
            {{ i18n.t('/change-order/bulk-price/download-results') }}
          </app-button>
        </div>
        <uploaded-file-preview :file-contents="fileContents" />
      </div>
    </div>
  </cst-page-template>
</template>
<script>
import CstPageTemplate from '@/templates/CstPageTemplate.vue'
import HeaderMenu from '@/components/generic/presentational/molecules/headerMenu/HeaderMenu.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import UploadedFilePreview from '@/components/futurePrices/presentational/molecules/UploadFilePreview/UploadedFilePreview.vue'
import BulkUploadFuturePrices from '@/components/futurePrices/presentational/molecules/BulkUploadFuturePrices/BulkUploadFuturePrices.vue'
import BulkFuturePricesService from '@/services/bulkFuturePricesService'

export default {
  components: {
    BulkUploadFuturePrices,
    CstPageTemplate,
    HeaderMenu,
    AppButton,
    UploadedFilePreview,
  },
  props: {
    jobId: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      fileContents: null,
      isProcessing: false,
      processingComplete: false,
      progress: 0,
    }
  },
  computed: {
    isFinishedProcessing() {
      if (this.fileContents) {
        return this.fileContents?.DataRecords?.every((record) => record.Status === 'PROCESSED')
      }
      return true //there are no file contents, which is equal being done
    },
  },
  created() {
    if (this.jobId) {
      this.loadFuturePriceJobDetails(this.jobId)
    }
  },
  methods: {
    async resetPage() {
      this.fileContents = null
      this.isProcessing = false
      this.processingComplete = false

      this.$router.push({ name: 'bulk-future-prices-page' })
    },
    async loadFuturePriceJobDetails(jobId) {
      try {
        const response = await BulkFuturePricesService.getFuturePriceJobDetails(jobId)
        this.fileContents = response.data

        if (response.data.Status === 'IN PROCESS') {
          this.isProcessing = true
          this.pollProgress()
        } else if (response.data.Status === 'COMPLETED') {
          this.isProcessing = false
          this.processingComplete = true
        } else {
          this.isProcessing = false
          this.processingComplete = false
        }
      } catch (error) {
        console.error('Error loading old Excel upload: ', error)
      }
    },
    handleFileUpload(fileContents) {
      this.fileContents = fileContents

      const jobId = fileContents.JobId

      this.$router.push({ name: 'bulk-future-prices-page', params: { jobId } })
    },
    async prepareForProcessing() {
      try {
        let jobId = this.fileContents.JobId
        this.isProcessing = true
        await BulkFuturePricesService.prepareForProcessing(jobId)
        this.pollProgress()
      } catch (error) {
        console.error('Error starting processing:', error)
      }
    },
    async pollProgress() {
      // Poll backend every X seconds for processing progress
      const interval = setInterval(async () => {
        const response = await BulkFuturePricesService.getFuturePriceJobDetails(this.jobId)
        this.fileContents = response.data
        if (response.data.Status === 'COMPLETED') {
          clearInterval(interval)
          this.isProcessing = false
          this.processingComplete = true
        }
      }, 3000)
    },
    async downloadResult() {
      try {
        let jobId = this.fileContents.JobId
        await BulkFuturePricesService.downloadResult(jobId)
      } catch (error) {
        console.error('Error downloading result:', error)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.bulk-future-prices-page {
  width: 100%;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.5rem 0;
  margin-bottom: 1.5rem;

  h1 {
    margin: 0;
    font-size: 1.75rem;
    color: $gray-darker;
  }
}

.process-actions {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.content-section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  display: grid;
  row-gap: 1.5rem;
}
</style>
